import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TenantIdInterceptor } from './tenant-id-interceptor/tenant-id-interceptor';
import { ErrorHandlingInterceptor } from './error-handling-interceptor/error-handling.interceptor';
import { JourneyHeadersInterceptor } from './journey-headers-interceptor/journey-headers.interceptor';
import { LanguageHeaderInterceptor } from './language-header-interceptor/language-header.interceptor';
import { Provider } from '@angular/core';
import { AuthInterceptor } from 'auth';

export const httpInterceptorProviders: Provider[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: JourneyHeadersInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LanguageHeaderInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TenantIdInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorHandlingInterceptor,
    multi: true,
  },
];
